import { Button } from '@superops/ui-design-system';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

/**
 * Cells are specific to the components using the table.
 * This action cell is used to delete a specific item in the table.
 */

function ActionCell(props) {
  const { cell } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;

  return (
    <div className="action-button">
      <Button onClick={() => actions.onClick([meta])}>
        <FormattedMessage id="common.remove" />
      </Button>
    </div>
  );
}

export default injectIntl(ActionCell);
